<template>
  <div class="counselTaskSelect">
    <div class="selectBox">
      <v-select
        attach
        label="大分類"
        item-text="displayName"
        item-value="brandCounselTypeId"
        v-model="majorTaskType"
        return-object
        :items="taskTypeList.major"
        :disabled="disabled"
        @change="changeTaskType(2)"
        class="UXselect"
        color="#6D8DFF"
        hide-details
        outline
        solo
        no-data-text="登録された内容がありません。"
      ></v-select>
    </div>
    <div class="selectBox">
      <v-select
        attach
        label="中分類"
        item-text="displayName"
        item-value="brandCounselTypeId"
        v-model="middleTaskType"
        return-object
        :items="taskTypeList.middle"
        :disabled="!majorTaskType || disabled"
        @change="changeTaskType(3)"
        class="UXselect"
        color="#6D8DFF"
        hide-details
        outline
        solo
        no-data-text="登録された内容がありません。"
      ></v-select>
    </div>
    <div class="selectBox">
      <v-select
        attach
        label="小分類"
        item-text="displayName"
        item-value="brandCounselTypeId"
        v-model="minorTaskType"
        return-object
        :items="taskTypeList.minor"
        :disabled="!middleTaskType || disabled"
        @change="changeTaskType(null)"
        class="UXselect"
        color="#6D8DFF"
        hide-details
        outline
        solo
        no-data-text="登録された内容がありません。"
      ></v-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'counsel-type',
  props: ['counselType', 'disabled', 'brandId', 'major', 'middle', 'minor'],
  data: () => ({
    majorTaskType: {},
    middleTaskType: {},
    minorTaskType: {},
    taskTypeList: {
      major: [],
      middle: [],
      minor: []
    },
    taskType: {
      gclass: { id: '', displayName: '' },
      lclass: { id: '', displayName: '' },
      sclass: { id: '', displayName: '' }
    }
  }),
  created () {
    this.unselected()
  },
  mounted () {
    this.getTaskTypeList(1)
    this.$eventBus.$on('unselected-counsel-type', () => {
      this.unselected()
    })
  },
  destroyed () {
    this.unselected()
  },
  watch: {
    brandId (value) {
      this.getTaskTypeList(1)
    },
    dnis () {
      this.getTaskTypeList(1)
    },
    major (value) {
      this.majorTaskType = this.major
      this.changeTaskType(2)
    },
    middle () {
      if (this.middle) {
        this.middleTaskType = this.middle
        this.changeTaskType(3)
      }
    },
    minor () {
      if (this.minor) {
        this.minorTaskType = this.minor
      }
    }
  },
  methods: {
    getTaskTypeList (level) {
      if (!this.brandId) return
      if (!level) {
        this.updateCounselType()
        return
      }
      let parentId = null
      switch (level) {
        case 2:
          parentId = this.majorTaskType.brandCounselTypeId
          break
        case 3:
          parentId = this.middleTaskType.brandCounselTypeId
          break
        default:
          parentId = null
          break
      }
      this.$http({
        method: 'get',
        url: `/api/brand/${this.brandId}/counsel-type`,
        params: {
          level: level,
          parentId: parentId
        }
      })
        .then((result) => {
          try {
            if (result.data.code === 0) {
              let type = {
                1: 'major',
                2: 'middle',
                3: 'minor'
              }
              this.taskTypeList[type[level]] = [...result.data.data]
              this.updateCounselType()
            } else {
              this.$alertMsg(result.data.message)
            }
          } catch (e) {
            console.log(e)
          }
        })
        .catch((err) => {
          this.$alertMsg(err)
        })
    },
    updateCounselType () {
      this.$emit('updateTaskType', this.taskType)
    },
    changeTaskType (level) {
      if (level === 2) {
        this.taskType.gclass.id = this.majorTaskType.brandCounselTypeId
        this.taskType.gclass.displayName = this.majorTaskType.displayName
        this.middleTaskType = null
        this.minorTaskType = null
        this.taskType.lclass.id = null
        this.taskType.lclass.displayName = null
        this.taskType.sclass.id = null
        this.taskType.sclass.displayName = null
      } else if (level === 3) {
        this.taskType.lclass.id = this.middleTaskType.brandCounselTypeId
        this.taskType.lclass.displayName = this.middleTaskType.displayName
        this.minorTaskType = null
        this.taskType.sclass.id = null
        this.taskType.sclass.displayName = null
      } else {
        this.taskType.sclass.id = this.minorTaskType.brandCounselTypeId
        this.taskType.sclass.displayName = this.minorTaskType.displayName
      }
      this.getTaskTypeList(level)
    },
    resetAll () {
      this.taskTypeList = []
      this.majorTaskType = null
      this.middleTaskType = null
      this.minorTaskType = null
    },
    unselected () {
      this.middleTaskList = []
      this.minorTaskList = []
      this.majorTaskType = null
      this.middleTaskType = null
      this.minorTaskType = null
    }
  }
}
</script>

<style lang="scss">
.counselTaskSelect {
  width: 100%;
  display: table;
  table-layout: fixed;

  .selectBox {
    position: relative;
    display: table-cell;
    padding-right: 5px;
    .v-list__tile {
      height: auto;
      .v-list__tile__title {
        overflow: visible;
        white-space: normal;
        word-break: break-all;
        height: auto;
        line-height: 1.5;
        padding: 10px 0;
      }
    }
    .v-select__selections {
      width: 87%;
    }
    &:last-child {
      padding-right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CounselTaskType.vue